<template>
	<div
		class="flex items-center gap-x-1 text-price-sale leading-none font-bold whitespace-nowrap"
		:aria-label="badgeOnly ? 'Výhodně' : String(price) + ' Kč - Výhodně'"
	>
		<span
			v-if="!badgeOnly"
			class="font-secondary text-2xl flex"
			:class="[{'sm:text-3xl': !smallPrice && !onlyLargePrice}, {'!text-3xl': onlyLargePrice}]"
			aria-hidden="true"
			v-html="formatPriceWithSuperscript(price, priceSize)"
		/>
		<span
			class="shrink-0 inline-flex items-center rounded-sm border border-current px-1"
			:class="sale ? 'py-px' : 'pt-[.0938rem] pb-px'"
			aria-hidden="true"
		>
			<span
				v-if="sale"
				class="text-[.75rem]"
				:class="{'sm:text-[.875rem]': !smallPrice}"
			>
				-{{ $n(sale / 100, {style: 'percent'}) }}
			</span>
			<NuxtIcon v-else name="custom/bargain" class="text-[2.75rem] [&_svg]:!h-auto" filled />
		</span>
	</div>
</template>

<script setup lang="ts">
	import type {
		ProductCatalogDTO_Models_BonusProgramPrice as BonusSale,
		Gsoa_ProductCatalog_ProductInHouse as Sale,
	} from '~/openapi';

	interface Props {
		price: number;
		sale?: Sale['discountPercentage'] | BonusSale['discount'];
		smallPrice?: boolean;
		onlyLargePrice?: boolean;
		badgeOnly?: boolean;
	}

	const props = defineProps<Props>();

	const priceSize = computed(() => {
		if (props.onlyLargePrice) { return 'text-[.875rem] -top-[0.75rem]'; }
		if (props.smallPrice) { return 'text-[.75rem] -top-[.5rem]'; }
		return 'text-[.75rem] -top-[0.5rem] sm:text-[14px] sm:-top-[0.75rem]';
	});
</script>
